import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { loadColors, loadColorsFailure, loadColorsSuccess } from './colors.actions';
import { ApiResponse } from '@shared';
import { ToastrService } from 'ngx-toastr';
import { ColorCombinationService } from '@services';

@Injectable()
export class ColorsEffect {
  constructor(
    private actions$: Actions,
    private _toast: ToastrService,
    private colorCombinationService: ColorCombinationService,
  ) {}
  loadColors$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadColors),
      mergeMap(() =>
        this.colorCombinationService.colorList().pipe(
          map((response: ApiResponse) => {
            if (response.status) {
              const colors = response.data;
              return loadColorsSuccess({ colors });
            } else {
              this._toast.error(response.message);
              return loadColorsFailure({ error: '[Colors] Load Colors Failure' });
            }
          }),
          catchError((error) => {
            this._toast.error(error || error.message);
            return of(loadColorsFailure({ error: '[Colors] Load Colors Failure' }));
          }),
        ),
      ),
    ),
  );
}
